import { render, staticRenderFns } from "./EnriquecimentoHome.vue?vue&type=template&id=203a0bdd"
import script from "./EnriquecimentoHome.vue?vue&type=script&lang=js"
export * from "./EnriquecimentoHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports